import React, { Component, Fragment } from "react";
import { withRouter, Link } from "react-router-dom";
import { ProgressBar, Image, Col, Row, } from "react-bootstrap";
import ReactTable from "react-table";
import debounce from "lodash/debounce";
import { NotificationManager } from "react-notifications";
import TasksService from "../../../services/TasksService";
import HandleError from "../../../services/HandleError";
import DeleteModal from "../../modals/DeleteModal";
import Materialicon from "../../helpers/Materialicon";
import TasksConfirmationModal from "../../modals/TasksConfirmationModal";
import TaskDetailsModal from "../../modals/TaskDetailsModal";
import { minutesToHourAndMinutes } from "../../helpers/HelperFunctions";
import { hasPermission } from "../../helpers/Permissions";

class MyTasksPage extends Component {
	state = {
		showTaskDetailsModal: false,
		showConfirmationModal: false,
		taskToDelete: null,
		isDeleting: false,
		isLoadingTable: true,
		actionLoading: false,
		selectedTaskDetails: {},
		message: "",
		data: [],
		pages: 1,
		tableColumns: [
			{
				Header: "Task Name",
				accessor: "name",
				Cell: cellInfo => (
					<button className="btn-name" onClick={() => this.handleTaskDetailsModal(cellInfo.original)}>{cellInfo.original.name}</button>
				),
				minWidth: 200
			}, {
				Header: "Project",
				accessor: "project_name",
				Cell: row => (<div className="text-center">{row.value}</div>),
				minWidth: 200
			}, {
				Header: "Status",
				accessor: "status_name",
				filterable: true,
				sortable: true,
				Cell(row) {
					switch (row.value) {
					case "to_do":
						return <div className="text-center"><span className="status status-to-do">To do</span></div>;
					case "done":
						return <div className="text-center"><span className="status status-done">Done</span></div>;
					case "in_progess":
						return <div className="text-center"><span className="status status-in-progress">In Progress</span></div>;
					default:
						return <div className="text-center"><span className="status status-default">{row.value}</span></div>;
					}
				}
			}, {
				Header: "Progress",
				accessor: "progress",
				filterable: false,
				sortable: false,
				Cell(cellInfo) {
					const status = cellInfo.original && cellInfo.original.status_id;
					const completed = cellInfo.value;
					if (status && completed >= 0) {
						let styleClass = "info";
						if (completed > 100) {
							styleClass = "danger";
						}
						else if (status == 3 && completed <= 100) {  // eslint-disable-line
							styleClass = "success";
						}
						return <ProgressBar bsStyle={styleClass} now={completed > 100 ? 100 : completed} label={`${completed}%`} />;
					}
					return "No progress!";
				}
			}, {
				Header: "Time Spent",
				accessor: "time_spent",
				filterable: false,
				sortable: false,
				Cell(row) {
					const { hours, minutes } = minutesToHourAndMinutes(row.value);
					return (
						<div className="text-center">
							{hours > 0 ? `${hours}h` : `${0}h`} {minutes > 0 ? ` and ${minutes}min` : null}
						</div>
					);
				}
			}, {
				Header: "Estimated",
				accessor: "estimated",
				filterable: false,
				sortable: false,
				Cell: (row) => {
					const { hours, minutes } = minutesToHourAndMinutes(row.value);
					return (
						<div className="text-center">
							{hours > 0 ? `${hours}h` : `${0}h`} {minutes > 0 ? ` and ${minutes}min` : null}
						</div>
					);
				}
			}, {
				Header: "Created by",
				accessor: "creator_name",
				Cell: row => (<div className="text-center"> {row.value} </div>),
				minWidth: 150
			}, {
				Header: "Parent",
				accessor: "parent_name",
				Cell: row => (<div className="text-center"> {row.value} </div>)
			},

		]
	}

	componentDidMount = () => {
		const canEditTask = hasPermission("task.update");
		const canDeleteTask = hasPermission("task.delete");
		this.setState({
			tableColumns: [...this.state.tableColumns, {
				Header: "Actions",
				accessor: "id",
				filterable: false,
				sortable: false,
				minWidth: 185,
				Cell: row => {
					const name = row.original.name || "";
					const isDirectlyLogged = row.original.is_directly_logged || null;
					let disableButton = false;
					if (row.original.status_id && parseInt(row.original.status_id, 0, 10) === 3) {
						disableButton = true;
					}
					return (
						<div className="text-center">
							<Link title="Task logs" to={`/tasks/${row.original.id}/logs`} className="btn-action material-icons btn-logs">list</Link>
							<button title="Finish task" disabled={disableButton} className="btn-action material-icons btn-accept" onClick={() => this.handleConfirmationModal(row.original, `You are changing "${name}" status to finished!`, "finish")}>done</button>
							{(canDeleteTask && canEditTask) &&
								<React.Fragment>
									{(isDirectlyLogged && (isDirectlyLogged === 1 || isDirectlyLogged === "1")) ? null : <Link title="Edit" to={`/tasks/${row.value}/edit`} className="btn-action material-icons btn-edit">edit</Link>}
									<button title="Delete" onClick={() => this.taskToDelete(row.original)} className="btn-action material-icons btn-delete">delete</button>
								</React.Fragment>
							}
						</div>
					);
				}
			}]
		});
	}

	getMyTasks = (state) => {
		const { pageSize, sorted, filtered, page } = state;
		const data = JSON.stringify({ pageSize, sorted, filtered, page });
		this.setState({ isLoadingTable: true });
		this.tasksService.fetchMyTasks(page + 1, `data=${data}`).then((res) => {
			this.setState({ isLoadingTable: false, data: res.data.data, pages: res.data.last_page, pageState: state });
		}).catch((err) => {
			this.setState({ isLoadingTable: false });
			HandleError(err, this);
		});
	}

	handleTaskDetailsModal = (task) => {
		if (task) {
			this.setState({
				showTaskDetailsModal: true,
				selectedTaskDetails: task
			});
		}
	}


	handleConfirmationModal = (task, message, action) => {
		if (task) {
			this.setState({
				showConfirmationModal: true,
				selectedTask: task,
				message,
				action
			});
		}
	}

	handleResponse = () => {
		if (this.state.selectedTask && this.state.selectedTask.id) {
			if (this.state.action === "finish") {
				this.handleChangeStatus(this.state.selectedTask.id);
			} else if (this.state.action === "duplicate") {
				this.handleDuplicateTask(this.state.selectedTask.id);
			}
		}
	}


	handleChangeStatus = (id) => {
		this.setState({ actionLoading: true });
		this.tasksService.changeStatus(id, { status_id: 3 }).then((res) => {
			this.setState({ actionLoading: false, showConfirmationModal: false, selectedTask: null });
			NotificationManager.success("Task finished.", "Success!");
		}).catch((err) => {
			this.setState({ actionLoading: false, showConfirmationModal: false, selectedTask: null });
			HandleError(err, this);
		}).then(() => {
			this.getMyTasks(this.state.pageState);
		});
	}

	handleDuplicateTask = (id) => {
		this.setState({ actionLoading: true });
		this.tasksService.duplicate(id).then((res) => {
			this.setState({ actionLoading: false, showConfirmationModal: false, selectedTask: null });
			NotificationManager.success("Task duplicated.", "Success!");
		}).catch((err) => {
			this.setState({ actionLoading: false, showConfirmationModal: false, selectedTask: null });
			HandleError(err, this);
		}).then(() => {
			this.getMyTasks(this.state.pageState);
		});
	}

	handleTaskDetailsClose = () => { this.setState({ showTaskDetailsModal: false }); }


	handleClose = () => { this.setState({ showConfirmationModal: false, selectedTask: null }); }

	taskToDelete = (skill) => {
		this.setState({ taskToDelete: { name: skill.name, id: skill.id } });
	}

	deleteTask = () => {
		if (this.state.taskToDelete) {
			this.setState({ isDeleting: true });
			this.tasksService.delete(this.state.taskToDelete.id).then((res) => {
				this.setState({ isDeleting: false });
				NotificationManager.success("Task deleted.", "Success!");
			}).catch((err) => {
				this.setState({ isDeleting: false });
				HandleError(err, this);
			}).then(() => {
				this.getMyTasks(this.state.pageState);
				this.closeModal();
			});
		}
	}

	closeModal = () => {
		this.setState({
			taskToDelete: null,
			isDeleting: false,
		});
	}

	tasksService = new TasksService(this);

	render() {
		const canAddTask = hasPermission("task.create");
		const { data, isLoadingTable, pages, tableColumns, showConfirmationModal, message, actionLoading } = this.state;
		return (
			<div className="crud-page edit-task-page">
				<div className="container-fluid">
					<section className="actions">
						<Row>
							<Col md={6} sm={6} xs={12}>
								<h2 className="page-title">My Tasks</h2>
							</Col>
							{canAddTask &&
								<Col md={6} sm={6} xs={12}>
									<Link to="/tasks/create-task" className="pull-right btn-add-big btn btn-default">
										<Materialicon icon="add_circle_outline" /> Add Task
    							</Link>
								</Col>
							}
						</Row>
					</section>
					<div className="card card-top-border connection-card fadeInLoadUp">
						<ReactTable
							columns={tableColumns}
							manual
							data={data}
							pages={pages}
							loading={isLoadingTable}
							onFetchData={debounce(this.getMyTasks, 400)}
							filterable
							defaultSorted={[{ id: "created_at", desc: true }]}
							defaultPageSize={20}
							className="-highlight"
						/>
					</div>
				</div>

				<TaskDetailsModal
					showTaskDetailsModal={this.state.showTaskDetailsModal}
					selectedTask={this.state.selectedTaskDetails}
					handleClose={this.handleTaskDetailsClose}
				/>

				<TasksConfirmationModal
					isLoading={actionLoading}
					message={message}
					showConfirmationModal={showConfirmationModal}
					handleResponse={this.handleResponse}
					handleClose={this.handleClose}
				/>

				<DeleteModal
					itemToDelete={this.state.taskToDelete}
					deleteItem={this.deleteTask}
					isDeleting={this.state.isDeleting}
					closeModal={this.closeModal}
				/>

			</div>
		);
	}
}

export default MyTasksPage;




// WEBPACK FOOTER //
// ./src/components/pages/tasks/MyTasksPage.js